import React, { useEffect, useState } from "react";
import { apiGet } from "@/lib/api";
import { useSEO } from "@/lib/seo";
import LocationCard from "@/components/common/LocationCard";
import { Breadcrumbs, GridSkeleton, ErrorState } from "@/components/common/states";

export default function Locations() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useSEO({ title: "Property Locations in Pune", description: "Explore Pune's key residential and commercial neighbourhoods — Wakad, Baner, Balewadi, Hinjewadi, Kharadi and more.", path: "/locations" });

  const load = () => { setData(null); setError(false); apiGet("/locations").then(setData).catch(() => setError(true)); };
  useEffect(load, []);

  return (
    <div className="ec-container py-8 sm:py-12">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Locations" }]} />
      <div className="mt-4 mb-8">
        <h1 className="font-display text-3xl sm:text-4xl text-foreground">Explore Pune by Location</h1>
        <p className="text-muted-foreground mt-2">Get to know Pune's neighbourhoods and find property in the area that suits you.</p>
      </div>
      {error ? <ErrorState onRetry={load} /> : data === null ? <GridSkeleton /> : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {data.map((l, i) => <LocationCard key={l.slug} location={l} index={i} />)}
        </div>
      )}
    </div>
  );
}
